/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import { UserButton } from '@clerk/clerk-react';
import { Fingerprint, NotebookPen, ReceiptText, Wrench } from 'lucide-react';

import { Skeleton } from '@/components/ui/skeleton';

type UserNavProps = {
    hasSuperUserPermissions?: boolean;
};

export const UserNav = ({ hasSuperUserPermissions }: UserNavProps) => {
    return (
        <UserButton
            appearance={{ elements: { avatarBox: 'h-8 w-8' } }}
            fallback={<Skeleton className="h-8 w-8 rounded-full" />}
        >
            <UserButton.MenuItems>
                <UserButton.Link label="Organisation" labelIcon={<Wrench size={14} />} href="/organisation/general" />
                <UserButton.Link
                    label="Terms"
                    labelIcon={<ReceiptText size={14} />}
                    href="https://drive.google.com/file/d/1Vh0Hprfb89f_jfZk-AAmdf27GIxK0KUV/view?usp=sharing"
                />
                {hasSuperUserPermissions && (
                    <UserButton.Link label="Admin" labelIcon={<Fingerprint size={14} />} href="/admin" />
                )}
                <UserButton.Link label="Release notes" labelIcon={<NotebookPen size={14} />} href="/release-notes" />
            </UserButton.MenuItems>
        </UserButton>
    );
};
